import { gql } from 'apollo-angular';

export const LIST_AGENTS_BY_COMPANY = gql`
  query ListAgentsByCompany($pageableParam: PageableParamInput, $companyUuid: UUID) {
    listAgentsByCompany(pageableParam: $pageableParam, companyUuid: $companyUuid) {
      first
      hasContent
      hasNext
      hasPrevious
      last
      number
      numberOfElements
      size
      totalElements
      totalPages
      content {
        active
        address
        attachableDiscriminator
        bucketName
        companyName
        declarantName
        declarantTitle
        declarationAccepted
        declarationAcceptedAt
        discriminator
        email
        name
        otherAttachmentName
        phoneNumber
        registrationDate
        registrationNumber
        registrationStatus
        registrationType
        tasacExpireDate
        tasacIssuingOffice
        tasacLicenseCategory
        tasacRegDate
        tasacRegistrationNumber
        tin
        type
        uuid
        agentType {
          code
          name
          uuid
        }
      }
    }
  }
`;

export const GET_AGENT_REGISTRATION = gql`
  query GetAgentRegistration($agentUuid: UUID) {
    getAgentRegistration(agentUuid: $agentUuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        address
        attachableDiscriminator
        bucketName
        companyName
        declarantName
        declarantTitle
        declarationAccepted
        declarationAcceptedAt
        discriminator
        email
        name
        otherAttachmentName
        phoneNumber
        registrationDate
        registrationNumber
        registrationStatus
        registrationType
        tasacExpireDate
        tasacIssuingOffice
        tasacLicenseCategory
        tasacRegDate
        tasacRegistrationNumber
        tin
        type
        uuid
        agentType {
          active
          code
          name
          uuid
        }
        attachments {
          active
          id
          minioObjectName
          otherAttachmentName
          uuid
          attachable {
            attachableDiscriminator
            bucketName
            id
            otherAttachmentName
            registrationType
            uuid
          }
          attachmentType {
            active
            fileSize
            fileType
            id
            kind
            name
            uuid
          }
        }
      }
    }
  }
`;
